import { Table, Thead, Tbody, Tr, Th, Td } from '@components/core-ui/Table/Table';
import { NoticeExtractorKeytermsResponseDto } from 'app/API';

type TProps = {
  keyterms?: NoticeExtractorKeytermsResponseDto;
};

export function KeytermsCard({ keyterms }: TProps) {
  const terms = keyterms?.terms ?? [];

  return (
    <section className="col-span-2 min-w-0 rounded-[10px] border border-border bg-surface-muted p-3 text-foreground max-[860px]:col-span-1">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h3 className="m-0 text-sm font-bold leading-5 text-foreground">Keyterms</h3>
        <span className="text-[11px] font-bold uppercase leading-[14px] text-foreground-muted">
          {terms.length}/{keyterms?.maxRecommendedTerms ?? 120}
        </span>
      </div>

      {terms.length ? (
        <div className="grid gap-2">
          <div className="flex flex-wrap gap-1.5">
            {keyterms?.keytermsPrompt.map((term) => (
              <span
                className="rounded-[6px] border border-border bg-surface px-2 py-1 text-xs font-bold leading-4 text-foreground"
                key={term}
                title={term}
              >
                {term}
              </span>
            ))}
          </div>

          <div className="max-h-[340px] overflow-auto rounded-[8px] border border-border bg-surface">
            <Table className="w-full border-collapse text-left text-xs leading-[18px]">
              <Thead className="sticky top-0 bg-surface-muted text-[11px] uppercase text-foreground-muted">
                <Tr>
                  <Th className="w-[52px] px-2 py-1.5 font-bold">Rank</Th>
                  <Th className="px-2 py-1.5 font-bold">Term</Th>
                  <Th className="w-[76px] px-2 py-1.5 font-bold">Score</Th>
                  <Th className="w-[130px] px-2 py-1.5 font-bold">Category</Th>
                </Tr>
              </Thead>
              <Tbody>
                {terms.map((term) => (
                  <Tr className="border-t border-border" key={`${term.rank}-${term.term}`}>
                    <Td className="px-2 py-1.5 text-foreground-muted">{term.rank}</Td>
                    <Td
                      className="whitespace-normal break-words px-2 py-1.5 font-bold text-foreground"
                      title={term.reason}
                    >
                      {term.term}
                    </Td>
                    <Td className="px-2 py-1.5 text-foreground-muted">{term.importanceScore}</Td>
                    <Td className="px-2 py-1.5 text-foreground-muted">{term.category}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
        </div>
      ) : (
        <div className="rounded-[8px] border border-dashed border-border bg-surface p-3 text-xs leading-[18px] text-foreground-muted">
          No keyterms were generated for this notice extraction.
        </div>
      )}
    </section>
  );
}
